<template>
    <div>
        <div class="registr">
            <footerTitle>隐私保护</footerTitle>
            <dl class="topDesc">
                <dt>
                    <h3>{{privacyPledgeList.topContent}}</h3>
                </dt>
                <dd>{{privacyPledgeList.topDesc}}</dd>
            </dl>
            <ul>
                <li v-for="item in privacyPledgeList.children" :key="item.title">
                    <h3>{{item.title}}</h3>
                    <template v-for="(child,index) in item.content">
                        <p :class="[child.bold?'bold':'',child.topDistance?'topHeight':'']">{{child.desc}}</p>

                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import footerTitle from '_c/footerTitle'
import { privacyPledgeList} from './dataList.js'
export default {
    components: { footerTitle },
    data() {
        return {
            privacyPledgeList,
        }
    }

}
</script>

<style lang="scss" scoped>
.registr {
    width: 917px;
    padding-bottom: 300px;
    .topDesc {
        padding: 10px;
        dt {
            h3 {
                color: #000;
            }
        }
        dd {
            margin-top: 30px;
            color: #757272;
            font-size: 16px;
        }
    }
    ul {
        padding: 10px;
        h3 {
            margin-top: 20px;
            color: #000;
        }
        p {
            margin-top: 20px;
            color: #757272;
            font-size: 16px;
        }
        .bold {
            font-weight: bold;
            color: #000;
        }
        .topHeight{
            margin-top: 5px;
        }
    }
}
</style>